module.exports = __webpack_public_path__ + "static/media/Muli-Bold.077ceb91.ttf";